import { useContext } from 'react';
import { ModalContext } from 'mc-react-redux-modal';
import useDeviceScreen from 'root/hooks/useDeviceScreen';

export const useModal = () => {
  const { isTablet, isPhone } = useDeviceScreen();
  const { modalActions } = useContext(ModalContext);

  const styles = {
    widthModal: '420px',
    heightModal: 'min-content'
  };

  const handleOpenModal = (modalType, modalProps = styles) => {
    const closeModal = modalActions.hideModal();
    const { widthModal, heightModal } = modalProps;
    let content = {};
    let width = widthModal;
    let height = heightModal;

    if (isTablet) {
      width = '100%';
      content = { ...content, left: '0', right: '0' };
    }
    if (isPhone) {
      height = '100%';
      content = { ...content, left: '0', right: '0', top: '0', bottom: '0' };
    }

    return modalActions.showModal({
      modalProps: {
        closeModal,
        height,
        width,
        styles: {
          content,
          overlay: {
            zIndex: 2147483648
          }
        }
      },
      modalType
    });
  };

  return { handleOpenModal };
};
